import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { Status } from '../model/status';
import { StatusSerializer } from '../model/serializer/status-serializer';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class StatusService extends ApiService<Status> {

  constructor(httpClient: HttpClient) {
    super(httpClient,
      environment.apiUrl,
      'job/status',
      new StatusSerializer());
  }
}
